









































































































































































import { MacAddressRegex } from '@/constants/device-management'
import { DeviceManagementActions } from '@/constants/device-management'

export default {
  props: {
    stageIndex: {
      type: Number,
      required: true,
    },
    deviceManagementAction: {
      type: String,
      required: true,
    },
    currentGatewayId: {
      type: String,
      required: true,
    },
    currentDeviceIndex: {
      type: Number,
      required: true,
    },
    selectedDevices: {
      type: Array,
      default: () => [],
    },
    allDevices: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      manualDeviceId: '',
      scanForDeviceId: '',
      skipDevice: false,
      deviceIdIsValid: false,
      isScanningForDeviceIds: false,
      isAttemptingGatewayConnection: false,
      nearbyDeviceIds: [],
    }
  },

  computed: {
    isReplaceDeviceAction() {
      return this.deviceManagementAction === DeviceManagementActions.ReplaceDevices
    },
    currentDevice() {
      return this.selectedDevices[this.currentDeviceIndex]
    },
    currentDeviceIsValid() {
      return this.currentDevice.hasSuccessfulGatewayConnection || this.currentDevice.hasSkippedGatewayConnection
    },
    hasFoundNearbyDevices() {
      return this.nearbyDeviceIds.length > 0
    },
    devicesForWizardStageHeader() {
      return this.selectedDevices.map(device => {
        const isCurrentDevice = device.name === this.selectedDevices[this.currentDeviceIndex].name
        return {
          ...device,
          isCurrentDevice,
          statusColor: device.hasSuccessfulGatewayConnection
            ? 'green'
            : isCurrentDevice
            ? 'device-management-blue'
            : 'dark-grey',
        }
      })
    },
    allSelectedDevicesConnected() {
      return this.selectedDevices
        .filter(device => device.isSelected)
        .every(device => (device.hasSuccessfulGatewayConnection ? true : false))
    },
    connectButtonIsDisabled() {
      if (this.currentDevice.hasSuccessfulGatewayConnection) {
        return true
      }
      if (this.deviceIdIsValid) {
        return this.isAttemptingGatewayConnection
      }
      return true
    },
    connectButton() {
      const isGreyedOut = !this.deviceIdIsValid || this.isAttemptingGatewayConnection
      const isConnected = this.currentDevice.hasSuccessfulGatewayConnection
      return {
        color: isConnected ? 'green' : 'device-management-blue',
        isDepressed: isConnected,
        isConnected: isConnected,
        icon: isConnected ? 'mdi-check-circle-outline' : 'mdi-access-point',
        text: isConnected ? 'Device Connected' : 'Connect to Gateway',
        isDisabled: isGreyedOut,
        action: isConnected ? () => {} : this.connectDeviceToGateway,
      }
    },
    scanForDeviceIdsButtonIsDisabled() {
      return (
        this.isScanningForDeviceIds ||
        this.isAttemptingGatewayConnection ||
        this.currentDevice.hasSkippedGatewayConnection
      )
    },
    idFieldsAreDisabled() {
      return this.currentDevice.hasSkippedGatewayConnection
    },
    idFieldsAreReadOnly() {
      return this.currentDevice.hasSuccessfulGatewayConnection
    },
    skipDeviceFieldIsDisabled() {
      return this.currentDevice.hasSuccessfulGatewayConnection
    },
    showSuccessfulConnectionMessage() {
      return this.currentDevice.hasSuccessfulGatewayConnection
    },
    showFailedConnectionMessage() {
      return this.currentDevice.hasAttemptedConnection && !this.currentDevice.hasSuccessfulGatewayConnection
    },
    manualDeviceIdRules() {
      if (!this.scanForDeviceId && !this.currentDevice.hasSuccessfulGatewayConnection) {
        return [
          v => {
            return !!v || 'Please enter your device ID'
          },
          v =>
            MacAddressRegex.test(v) ||
            'Please double check your device ID. A valid ID has 6 pairs of characters separated by colons. For example: 01:23:45:67:89:AB',
        ]
      }
      return []
    },
    scanForDeviceIdRules() {
      if (!this.hasFoundNearbyDevices) {
        return []
      }
      if (!this.manualDeviceId && !this.currentDevice.hasSuccessfulGatewayConnection) {
        return [
          v => {
            return (
              !!v ||
              'Please select a device ID. If you do not see the device ID you are looking for, try entering it manually under "Option 1"'
            )
          },
        ]
      }
      return []
    },
  },

  watch: {
    currentDeviceIndex: {
      handler() {
        this.clearManualDeviceId()
        this.clearScanForDeviceId()
        this.$refs.deviceIdForm.resetValidation()
        this.skipDevice = this.currentDevice.hasSkippedGatewayConnection
        if (!this.currentDevice.hasSuccessfulGatewayConnection && !this.currentDevice.hasSkippedGatewayConnection) {
          this.scanForDeviceIds()
        }
      },
    },
    currentDeviceIsValid: {
      immediate: true,
      handler(newVal, oldVal) {
        this.$emit('stageIsValid', {
          stageIndex: this.stageIndex,
          isValid: newVal,
        })
      },
    },
  },

  mounted() {
    this.scanForDeviceIds()
  },

  methods: {
    getDeviceHeaderIcon(device) {
      if (device.hasSuccessfulGatewayConnection) {
        return 'mdi-check-circle-outline'
      }
      if (device.hasSkippedGatewayConnection) {
        return 'mdi-close-circle-outline'
      }
      return 'mdi-minus-circle-outline'
    },
    scanForDeviceIds() {
      if (this.isScanningForDeviceIds) {
        return
      }
      console.info(`this function will scan for device Ids`)
      try {
        this.isScanningForDeviceIds = true
        setTimeout(() => {
          this.nearbyDeviceIds = ['A5:2E:A3:58:92:B8', 'D2:58:32:BE:CF:E8', 'XD:SF:Q1:14:DH:ID']
          this.isScanningForDeviceIds = false
        }, 4000)
      } catch (err) {
        console.log(err)
      }
    },
    connectDeviceToGateway() {
      const deviceId = this.manualDeviceId || this.scanForDeviceId
      console.info(
        `this function will connect the specified device (${deviceId}) to the current gatewayId (${this.currentGatewayId})`
      )
      try {
        this.isAttemptingGatewayConnection = true
        setTimeout(() => {
          this.isAttemptingGatewayConnection = false
          this.$emit('setDeviceGatewayConnection', {
            ...this.currentDevice,
            hasAttemptedGatewayConnection: true,
            hasSuccessfulGatewayConnection: true,
            deviceId,
          })
        }, 2000)
      } catch (err) {
        console.log(err)
        this.$emit('setDeviceGatewayConnection', {
          ...this.currentDevice,
          hasAttemptedGatewayConnection: true,
          hasSuccessfulGatewayConnection: false,
          deviceId,
        })
      }
    },
    clearManualDeviceId() {
      this.manualDeviceId = ''
    },
    clearScanForDeviceId() {
      this.scanForDeviceId = ''
    },
    skipDeviceAction(e) {
      this.clearManualDeviceId()
      this.clearScanForDeviceId()
      this.$refs.deviceIdForm.resetValidation()
      this.$emit('setDeviceGatewayConnection', {
        ...this.currentDevice,
        hasSkippedGatewayConnection: e,
      })
    },
  },
}
